module.exports = __webpack_public_path__ + "img/female-condom.ab90d17b.png";